/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Segment, Dimmer, Loader, Form, List, Grid } from 'semantic-ui-react'

import MenuActions from '../../../reducers/menuReducer'

class CategoriesField extends React.PureComponent {
  componentDidMount() {
    const { fetchMenus, loaded } = this.props

    if (!loaded) {
      fetchMenus()
    }
  }

  renderMenu = () => {
    const { menus } = this.props

    return _.map(menus, (eachMenu, key) => {
      return (
        <Grid.Row key={key}>
          <Grid.Column width={2} style={{ flex:  'unset' }}>
            <strong>{eachMenu.name}</strong>
          </Grid.Column>
          <Grid.Column width={14} style={{ flex:  'unset' }}>
            <Form.Group inline style={{ marginBottom: 0 }}>
              <List horizontal>
                {this.renderMenuCategories(eachMenu)}
              </List>
            </Form.Group>
          </Grid.Column>
        </Grid.Row>
      )
    })
  }

  renderMenuCategories = menu => {
    const { value, onChange } = this.props

    return _.map(menu.categories || {}, (category, key) => {
      return (
        <List.Item key={key}>
          <Form.Checkbox
            label={category.name}
            key={key}
            onChange={(e, data) => onChange(key, data.checked)}
            checked={value[key]}
          />
        </List.Item>
      )
    })
  }

  render() {
    const { loading } = this.props

    return (
      <Form.Field>
        <label>Categories</label>
        <Segment style={{ minHeight: 100, marginTop: 10, paddingTop: 0, paddingBottom: 0 }}>
          <Dimmer active={loading} inverted>
            <Loader inverted content="Loading" />
          </Dimmer>
          <Grid style={{ margin: '15px 0px' }}>
            {this.renderMenu()}
          </Grid>
        </Segment>
      </Form.Field>
    )
  }
}

const mapStateToProps = ({ menus }) => ({
  loaded: menus.loaded,
  loading: menus.loading,
  menus: menus.data,
})

const mapDispatchToProps = dispatch => ({
  fetchMenus: () => dispatch(MenuActions.fetchMenusRequest()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoriesField)



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/categoriesField.js